export enum SalesActionEnum {
  // id: number = null;
  // name: string = null;
  New = 1,
  Renew = 2,
  Convert = 3,
  Extend = 4,
  Adjustment = 5,
  DepositReplenishment = 6,
}
